{
    "mcpPermissions": {
        "menu": "MCP-verktygsbehörigheter",
        "title": "MCP-verktygsbehörigheter",
        "info": {
            "interim": "En tom behörighetslista ger för närvarande åtkomst till ALLA verktyg (tillfällig policy). För att faktiskt begränsa en användare måste minst ett verktyg vara markerat."
        },
        "column": {
            "permissions": "MCP-behörigheter"
        },
        "badge": {
            "unrestricted": "Obegränsad (alla verktyg)"
        },
        "filter": {
            "tools": "Filtrera verktyg…"
        },
        "action": {
            "selectAll": "Markera alla",
            "clearAll": "Avmarkera alla"
        },
        "save": "Spara",
        "loadError": "Kunde inte ladda verktygsbehörigheter",
        "emptyWarn": {
            "header": "Tom behörighetslista ger ALLA verktyg",
            "message": "Dessa användare skulle få en tom behörighetslista, som för närvarande ger åtkomst till ALLA verktyg (tillfällig policy): {users}. För att faktiskt begränsa dem, behåll minst ett verktyg markerat. Spara ändå?",
            "accept": "Spara ändå"
        },
        "dialog": {
            "title": "MCP-behörigheter — {name}",
            "saved": "MCP-behörigheter uppdaterade",
            "saveError": "Kunde inte uppdatera MCP-behörigheter"
        }
    }
}
